/* eslint-disable camelcase */
import qs from 'query-string';
import { AccountVerificationMethod } from '../constants/resourceVerification';
import {
    EmailValidation,
    EmailValidationSources,
} from '../constants/verification';
import {
    VerificationMethodSnapshot,
    VerificationBalancerSnapshot,
    VerificationSnapshot,
} from '../models/Verification';
import api from './api';
import { getBackVersion } from '../config';

const getLastVerification = (
    methods: AccountVerificationMethod[]
): Promise<VerificationSnapshot> =>
    api.request<VerificationSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/account/verification`,
        params: {
            methods: methods,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'none' });
        },
    });

const requestVerification = (
    method: AccountVerificationMethod,
    value?: string
): Promise<VerificationSnapshot | VerificationMethodSnapshot> =>
    api.request<VerificationSnapshot | VerificationMethodSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/account/verification`,
        action: 'REQUEST_VERIFICATION',
        params: {
            method: method,
            value: value,
        },
    });

const verify = (
    method: AccountVerificationMethod,
    code: string,
    value?: string
): Promise<void> =>
    api.request<void>({
        method: 'PATCH',
        url: `${getBackVersion()}/account/verification`,
        action: 'CONFIRM_VERIFICATION',
        data: {
            method: method,
            value: value,
            code: code,
        },
    });

const getBalancer = (): Promise<VerificationBalancerSnapshot> =>
    api.request<VerificationBalancerSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/account/verification/balancer`,
    });

const validateEmail = (
    email: string,
    source: EmailValidationSources
): Promise<EmailValidation> =>
    api.request<EmailValidation>({
        method: 'POST',
        action: 'EMAIL_VALIDATION_REQUEST',
        url: `${getBackVersion()}/email_validation`,
        data: { email, source },
    });

export default {
    getBalancer,
    getLastVerification,
    requestVerification,
    verify,
    validateEmail,
};
